import { SortDirection } from '@celum/common-components';
import { PaginationOption } from '@celum/shared/domain';

export enum SpecificationTypeFilter {
  DOWNLOAD = 'DOWNLOAD',
  OTHERS = 'OTHERS'
}

export interface FormatFilters extends PaginationOption {
  formatKey?: string;
  formatName?: string;
  specificationTypes?: SpecificationTypeFilter[];
  specifications?: string[];
  sort?: string[];
  page?: number;
  size?: number;
}

export function createEmptyFormatFilter(): FormatFilters {
  return {
    sort: createDefaultFormatFilterSort()
  };
}

export function createDefaultFormatFilterSort(): string[] {
  return ['createdAt', SortDirection.DESC];
}
